import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const ErrorModal = ({ open, onClose, data }) => {
  console.log(data, "798797798798");

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle className="text-center fw-bold">
        Quickbooks Deleted or Inactive Item Status
      </DialogTitle>
      <DialogContent>
        {data.map((item, index) => (
          <div key={index} className=" my-3">
            <div className="row align-items-center">
              <p className="col-md-8 mb-1">
                <span className="fw-bold">Item Name:</span> {item?.ItemName}
              </p>
              <p className="col-md-4 mb-1">
                <span className="fw-bold">Quickbook ID:</span>{" "}
                {item?.Itemvariationid}
              </p>
            </div>
            <div className="text-secondary">
              <span className="fw-bold">Quickbook Reason:</span> {item?.Reason}
            </div>
          </div>
        ))}
      </DialogContent>
      <DialogActions className="d-flex justify-content-center">
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;
